import { ProductThumb } from './ProductThumb';
import { CopyableValue } from './CopyableValue';

function getAsin(item, marketplace) {
  return marketplace === 'IN' ? item.asinIn || item.asinCom : item.asinCom || item.asinIn;
}

export function OrderLineProducts({
  order,
  className = '',
  urgent = false,
  amazonStyle = false,
  showOrderId = false,
}) {
  const items = order?.items || [];
  const stackMeta = amazonStyle || showOrderId;

  if (!items.length) {
    return <span className="text-sm text-slate-500">—</span>;
  }

  const [first, ...rest] = items;
  const asin = getAsin(first, order.marketplace);
  const mutedClass = urgent ? 'text-red-600' : 'text-slate-500';
  const restTotalQty = rest.reduce(
    (sum, item) => sum + (Number(item.quantityOrdered) || 1),
    0
  );

  return (
    <div className={`grid gap-2 ${className}`.trim()}>
      <div className="flex items-start gap-3">
        <ProductThumb
          item={{
            title: first.title,
            asinIn: order.marketplace === 'IN' ? first.asinIn : null,
            asinCom: order.marketplace === 'US' ? first.asinCom : null,
            imageUrl: first.imageUrl,
          }}
          marketplace={order.marketplace}
        />
        <div className="min-w-0">
          <p
            className={[
              'line-clamp-2 text-sm font-medium',
              urgent ? 'font-semibold text-red-700' : 'text-slate-900',
            ].join(' ')}
          >
            {first.title || 'Untitled product'}
          </p>
          {stackMeta ? (
            <div className={`mt-0.5 grid gap-0.5 text-xs leading-normal ${mutedClass}`}>
              {order.amazonOrderId ? (
                <p className="flex flex-wrap items-center gap-x-1">
                  <CopyableValue label="Order ID" value={order.amazonOrderId} />
                  {(asin || first.sku) ? <span aria-hidden="true">·</span> : null}
                </p>
              ) : null}
              {asin ? (
                <p className="flex flex-wrap items-center gap-x-1">
                  <CopyableValue label="ASIN" value={asin} />
                  {first.sku ? <span aria-hidden="true">·</span> : null}
                </p>
              ) : null}
              {first.sku ? (
                <p className="flex flex-wrap items-center gap-x-1">
                  <CopyableValue label="SKU" value={first.sku} />
                  <span aria-hidden="true">·</span>
                  <span>Qty {first.quantityOrdered || 1}</span>
                </p>
              ) : (
                <p>Qty {first.quantityOrdered || 1}</p>
              )}
            </div>
          ) : (
            <p
              className={[
                'mt-0.5 flex flex-wrap items-center gap-x-1 text-xs',
                mutedClass,
              ].join(' ')}
            >
              {asin ? (
                <CopyableValue label="ASIN" value={asin} />
              ) : (
                <span>ASIN —</span>
              )}
              {first.sku ? (
                <>
                  <span aria-hidden="true">·</span>
                  <CopyableValue label="SKU" value={first.sku} />
                </>
              ) : null}
              <span aria-hidden="true">·</span>
              <span>Qty {first.quantityOrdered || 1}</span>
            </p>
          )}
        </div>
      </div>
      {rest.length ? (
        <p className="text-[11px] font-medium text-slate-500">
          +{rest.length} more item(s)
          {restTotalQty > 0 ? ` · Qty ${restTotalQty}` : ''}
        </p>
      ) : null}
    </div>
  );
}
